export default {
  platformNotice: {
    receiver: "Nền tảng nhận",
    title: "Tiêu đề thông báo）",
    content: "Chi tiết nội dung thông báo",
    type: "vị trí hiển thị",
    type0: "trang chủ",
    status: "trạng thái",
    status0: "đợi gửi",
    status1: "đã gửi",
    status2: "bản nháp",
    startTime: "thời gian gửi",
    updateTime: "thời gian cập nhật",
    updateUserName: "người thao tác",
    messageWithdraw: "hủy bỏ？",
    messageSend: "gửi ngay？",
    remark: "thông báo",
    detail: "Thông tin chi tiết",
    tip: {
      receiver: "Chọn nền tảng nhận",
      type: "Chọn vị trí để hiển thị",
      title: "Vui lòng nhập 1-100 ký tự",
      content: "Vui lòng nhập 1-2000 ký tự",
      startTime: "Chọn thời gian gửi đi",
      remark: "Vui lòng nhập 1-200 ký tự",

    }
  }
}
